<template>
    <div class="bkg-color--white hover--shadow">
      <button ref="expandButton" @click="toggleWidget" class="plus-button mar-bottom--0"><span class="plus-button_icon">+</span></button>
      <b-collapse id="analytics" v-model="widgetIsOpen" class="mt-2 collapse--white">
          <button class="purple-button purple-button--full-width mx-auto"  @click="ruleSimple">New Guided Rule</button>
          <button v-show="crmType === 'salesforce'" class="purple-button purple-button--full-width mx-auto mt-3" @click="ruleRaw">New Raw SoQl Rule</button>
      </b-collapse>
    </div>
  </template>
<script>
export default {
  components: {
  },
  props: {
    crmType: {
      type: String
    }
  },

  data () {
    return {
      widgetIsOpen: false
    }
  },
  methods: {
    ruleSimple () {
      this.toggleWidget()
      this.$emit('simple')
    },
    ruleRaw () {
      this.toggleWidget()
      this.$emit('raw')
    },
    toggleWidget () {
      this.widgetIsOpen ? this.closeWidget() : this.openWidget()
    },
    openWidget () {
      this.widgetIsOpen = true
      this.$refs.expandButton.setAttribute('aria-expanded', true)
      this.$store.dispatch('ux/spotlightElement', { element: this.$el, runAfterTurningOff: this.closeWidget })
    },
    closeWidget () {
      this.widgetIsOpen = false
      this.$refs.expandButton.setAttribute('aria-expanded', false)
      this.$store.dispatch('ux/turnOffSpotlight')
    }
  },
  updated () {
    this.$store.commit('updateLeaderLines')
  }
}
</script>
